// extracted by mini-css-extract-plugin
export default {"container":"TabHeader_container__y0bnp","rightContainer":"TabHeader_rightContainer__eQGtn","userType":"TabHeader_userType__0ZbNc","headerBtn":"TabHeader_headerBtn__H17Ch"};